export function dataInRequest(params = {}) {
  return {
    type: '@tagcomrestricao/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@tagcomrestricao/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@tagcomrestricao/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@tagcomrestricao/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@tagcomrestricao/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@tagcomrestricao/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@tagcomrestricao/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@tagcomrestricao/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@tagcomrestricao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@tagcomrestricao/RECORD_FILTERING',
    payload: { params },
  };
}
